function Card(): any {
  return {
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: 'none'
        }
      }
    }
  };
}

export { Card };
